<dsp-content-card [types]="[ 'select', 'select' ]" [loading]="loading$ | async">
  <!-- <atlas-select *dsp-content-filter [id]="'esg-year-filter'" [(ngModel)]="year" [multiple]="false"
    [placeHolder]="'Pick One'" [disabled]="!(years$ | async).length"
    [(ngModel)]="year" (ngModelChange)="onChangeYear($event)">
    <atlas-option *ngFor="let year of years$ | async" [value]="year" [selectedValue]="year">
      {{ year }}
    </atlas-option>
  </atlas-select> -->
  <atlas-field *dsp-content-filter>
    <atlas-field-label>As At Year</atlas-field-label>
    <atlas-select [id]="'esg-year-filter'" [(ngModel)]="year" [multiple]="false" [placeHolder]="'Pick One'"
      [disabled]="!(years$ | async).length" (ngModelChange)="onChangeYear($event)">
      <atlas-option *ngFor="let year of years$ | async" [value]="year" [selectedValue]="year">
        {{ year }}
      </atlas-option>
    </atlas-select>
  </atlas-field>

  <atlas-field *dsp-content-filter>
    <atlas-field-label>As At Month</atlas-field-label>
    <atlas-select [id]="'esg-month-filter'" [(ngModel)]="month" [multiple]="false" [placeHolder]="'Pick One'"
      [disabled]="!(months$ | async).length" (ngModelChange)="onChangeMonth($event)">
      <atlas-option *ngFor="let month of months$ | async" [value]="month.value" [selectedValue]="month.name">
        {{ month.name }}
      </atlas-option>
    </atlas-select>
  </atlas-field>

  <!-- <atlas-select *dsp-content-filter [id]="'esg-month-filter'" [(ngModel)]="month" [multiple]="false"
    [placeHolder]="'Pick One'" [disabled]="!(months$ | async).length" [(ngModel)]="month"
    (ngModelChange)="onChangeMonth($event)">
    <atlas-option *ngFor="let month of months$ | async" [value]="month.value" [selectedValue]="month.name">
      {{ month.name }}
    </atlas-option>
  </atlas-select> -->

  <div dsp-content>
    <div class="row">
      <div class="columns">
        <div *ngIf="message" class="alert" [ngClass]="(showEsgData$ | async) ? 'green-esg-msg' : 'red-esg-msg'">
          {{message}}
        </div>
        <atlas-tab-group class="dsp-esg-tabs" (selectedIndexChange)="onChangeTab($event)">
          <atlas-tab>
            <ng-template atlas-tab-label>

              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'" [haloTooltip]="esgHomeText"
                [size]="'large'" [icon]="'icon-home-24'">
              </atlas-icon>
            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="row">
                    <div class="columns">
                      <div class="dsp-title-container">
                        <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                          Sustainable Investment
                        </h3>
                      </div>
                      <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                        Sustainability is one of Mercer’s five global
                        <a href="https://www.multimanager.mercer.com.au/about/investment-beliefs.html"
                          target="_blank">investment
                          beliefs</a>.
                      </div>
                    </div>
                  </div>
                  <div class="row mos-u-spacer--padding-bottom-md mos-u-spacer--padding-left-sm">
                    <div class="Image columns small-12 medium-4 dsp-align-right mos-u-spacer--margin-top-lg">
                      <img class="mos-u-responsive-img esg-home" src="/assets/images/esg-home.png" alt="ESG Home">
                    </div>
                    <div class="text columns small-12 medium-8 dsp-align-left mos-u-spacer--margin-top-lg">
                      <div class="esg-pillar-desc">
                        We believe that taking a sustainable investment view is more likely to create and preserve
                        long-term
                        investment capital. Furthermore, we believe:
                      </div>
                      <br />
                      <div class="esg-pillar-desc-point mos-u-spacer--padding-left-md">
                        <p class="esg-pointer">
                          1. ESG risks can have a material impact on long-term risk and return outcomes.
                        </p>
                        <p class="esg-pointer">
                          2. Taking a broader and longer-term perspective on risk is likely to lead to improved risk
                          management
                          and new investment opportunities.
                        </p>
                        <p class="esg-pointer">
                          3. Climate change poses a systemic risk.
                        </p>
                        <p class="esg-pointer">
                          4. Active ownership helps the realization of long-term shareholder value.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row mos-u-spacer--padding-bottom-xlg">
                    <div class="Image columns small-12 medium-12 dsp-align-right">
                      <h2 class="esg-pillar-sub">Our Sustainable Investment Policy adopts a four pillar approach</h2>
                    </div>
                    <div class="Image columns small-12 medium-12 dsp-align-right">
                      <img class="mos-u-responsive-img esg-pillar" src="/assets/images/esg-pillar.png" alt="ESG Pillar">
                    </div>
                    <div class="Image columns small-12 medium-12 dsp-align-right">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'"
                [haloTooltip]="esgRatingAssessment" icon="questionnaire" collection="user-interface-solid"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      ESG Rating Assessment
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) " class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async)" class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-lg mos-u-spacer--margin-top-md">
                    The Mercer ESG ratings represent our global manager research team’s view on the extent to which
                    ESG
                    factors and active ownership practices are integrated into a manager’s investment decision making
                    process. The ratings are determined based on in-depth due diligence following Mercer’s Four Factor
                    Framework (Idea Generation, Portfolio Construction, Implementation, and Business Management).
                    <br />
                    <br />
                    There are four ESG ratings categories ranging from ESG1 (the highest rating) down to ESG4 (the
                    lowest rating).
                    <br />
                    <br />
                    <div class="Image small-12 medium-12 dsp-align-right">
                      <img class="mos-u-responsive-img esg-pillar" src="/assets/images/esg-rating.jpg" alt="ESG Pillar">
                    </div>
                    <br />
                    <p>
                      The Mercer Multi-Manager Fund ratings in this section reflect the weighted average ratings of the
                      underlying manager strategies that the funds invest in.
                    </p>
                  </div>

                  <div *ngIf="(esgRatingTable$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">
                        <thead atlas-table-header #header>
                          <tr atlas-table-row>
                            <th colspan="2">
                            </th>

                            <th colspan="3">
                              <strong>ESG Rating</strong>
                            </th>
                            <th colspan="3">
                              <strong> Universe ESG Rating</strong>
                            </th>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of headerEsgRating" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.name }}
                            </th>
                          </tr>
                        </thead>


                        <tbody atlas-table-body>
                          <tr halo-table-row *ngFor="let row of esgRatingTable$ | async | sort:header.sortOption">

                            <td atlas-table-cell>
                              {{row.name}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.allocation}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingFund.secondLastYear}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingFund.lastYear}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingFund.currentYear}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingUniverse.secondLastYear}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingUniverse.lastYear}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{row.esgRating.ratingUniverse.currentYear}}
                            </td>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgRatingTable$ | async).length" class="mos-u-spacer--margin-top-sm">
                        <div class="column medium-3 pagination-container" style="justify-content: left;">
                          <span>
                            Showing {{
                            (((pagination$ | async)?.page - 1) * (pagination$ | async)?.itemsByPage + 1)
                            }} to {{
                            getMin((pagination$ | async)?.page * (pagination$ | async)?.itemsByPage, (pagination$ |
                            async)?.total)
                            }} of {{ (pagination$ | async)?.total }} entries
                          </span>
                        </div>
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>

                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                  <div *ngIf="!((esgRatingTable$ | async)?.length > 0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(esgRatingTable$ | async)?.length > 0">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-ESR-export-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-ESR-download-button'" (click)="onExportPDF('esg-rating')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-ESR-export-button'" (click)="onExportCSV('esg-rating')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'"
                [haloTooltip]="esgCarbonFootPrint" [size]="'large'" icon="button-record"
                collection="multimedia-solid"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Carbon Footprint
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) " class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async)" class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-lg mos-u-spacer--margin-top-md">
                    The carbon footprint of the Mercer Multi-Manager Funds reflect the weighted average carbon intensity
                    (scope 1 + scope 2) of its underlying investments at a given point in time. Holdings are active and
                    vary over time, as such we also provide a comparison to market indices.
                    <br />
                    <br />
                    <i>
                      Scope 1 emissions are those from sources owned or controlled by the entity through direct
                      combustion of fuel, while scope 2 are indirect emissions associated with the generation of
                      purchased energy.
                      <br />
                      <br />
                      Scope 1 and 2 emissions are based on company published data and estimates where data is not
                      published.
                      <br />
                      <br />
                      Data source: MSCI ESG Manager
                    </i>
                  </div>
                  <div class="row mos-u-spacer--padding-bottom-md">
                    <div *ngIf="(esgCarbonFootPrintTable$ | async)?.length"
                      class="column dsp-chart-container esgChartBorder">
                      <div dsp-chart #esgCarbonFootPrintChart [chart]="carbonFootPrintChart$ | async" class="dsp-chart">
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(esgCarbonFootPrintTable$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">
                        <thead atlas-table-header #header>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of headerEsgCarbonFootPrint" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.name }}
                            </th>
                          </tr>
                        </thead>

                        <tbody atlas-table-body>
                          <tr halo-table-row
                            *ngFor="let row of esgCarbonFootPrintTable$ | async | sort:header.sortOption;let index=index">

                            <ng-container *ngIf="!row.parent">
                              <td atlas-table-cell
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">

                                {{ row.name }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected }">
                                {{ row.secondLastYear }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected }">
                                {{ row.lastYear }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected }">
                                {{ row.currentYear }}
                              </td>
                            </ng-container>
                            <ng-container *ngIf="row.parent">
                              <td atlas-table-cell
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">

                                {{ row.name }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected }">
                                {{ row.secondLastYear }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected }">
                                {{ row.lastYear }}
                              </td>
                              <td atlas-table-cell class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected }">
                                {{ row.currentYear }}
                              </td>
                            </ng-container>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgCarbonFootPrintTable$ | async).length" class="mos-u-spacer--margin-top-sm">
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>

                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                  <div *ngIf="!((esgCarbonFootPrintTable$ | async)?.length > 0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'"
                  *ngIf="(esgCarbonFootPrintTable$ | async)?.length > 0">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-CF-export-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-CF-download-button'" (click)="onExportPDF('carbon-footprint')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-CF-export-button'" (click)="onExportCSV('carbon-footprint')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'"
                [haloTooltip]="analyticsClimateTransition" [size]="'large'" [icon]="'icon-cloud-24'"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Analytics for Climate Transition
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) " class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async)" class="dsp-subtitle" style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                    The Analytics for Climate Transition (ACT) is a strategic forward-looking assessment of the
                    investment risks and opportunities that are set to arise from a transition to a low carbon economy.
                    <br />
                    The transition capacity of a fund is modelled on a spectrum of grey to green investments.
                    <br />
                    <img class="mos-u-responsive-img" src="/assets/images/esg_analytics_climate_transition.png"
                      alt="ESG ClIMATE TRANSITION">
                    <br />
                    ACT will play a key role in supporting Mercer and its clients’ climate transition plans, in line
                    with commitments to net-zero emissions by 2050.
                    <br />
                    <br />
                    Data source: Mercer proprietary analysis based on data from MSCI ESG Manager and ISS Datadesk
                  </div>
                  <div class="mos-u-spacer--padding-bottom-md">
                    <div *ngIf="((esgAnalyticsClimateTransitionCarbonWeightData$ | async) ===  undefined)
                    || ((esgAnalyticsClimateTransitionDataCarbonIntensity$ | async) ===  undefined)"
                      class="mos-u-align-center--both" [style.height.px]="100">
                      <h3>
                        No Data Available
                      </h3>
                    </div>
                    <div *ngIf="(esgAnalyticsClimateTransitionCarbonWeightData$ | async) !==  undefined"
                      class="dsp-chart-container esgChartBorder">
                      <div class="dsp-chart" dsp-chart #selectEsgAnalyticsClimateTransitionCarbonWeightData
                        [chart]="esgAnalyticsClimateTransitionCarbonWeightData$ | async"></div>
                    </div>
                  </div>
                  <div class="mos-u-spacer--padding-bottom-md">
                    <div *ngIf="(esgAnalyticsClimateTransitionDataCarbonIntensity$ | async) !==  undefined"
                      class="column dsp-chart-container esgChartBorder">

                      <div class="dsp-chart" dsp-chart #esgAnalyticsClimateTransitionDataCarbonIntensity
                        [chart]="esgAnalyticsClimateTransitionDataCarbonIntensity$ | async"></div>
                      <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                        <small class="mos-u-footnote">
                          Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                          Analysis may not be available for all funds across all time periods.<br>
                          Analysis is available from end June 2021 only.<br>
                          The most recently available Sustainable Investment Analysis is displayed as at the analysis
                          month
                          selected. </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-ACT-export-settings-button'">
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>
                    <legacy-dropdown-item>
                      <a [id]="'esg-ACT-download-button'" (click)="onExportPDF('climate-transition')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-ACT-export-button'" (click)="onExportCSV('climate-transition')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'" [haloTooltip]="esgUNDevGoals"
                [size]="'large'" [icon]="'icon-filter-add-24'"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      UN Sustainable Development Goals

                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) && (esgUNDevGoalsTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async) && (esgUNDevGoalsTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                    This analysis measures the net impact that the Mercer Multi-Manager Funds’ underlying investments
                    have on the UN Sustainable Development Goals (SDGs). By being able to measure this impact,
                    investments can actively support the transformation processes required to achieve these
                    environmental and social sustainability goals.
                    <br />
                    The impact ratings are a reflection of the extent to which revenue generated by a company either
                    contributes or obstructs the achievement of the UN SDGs, as well as accounting for the way the
                    company operates and any controversies linked to it.
                    <br />
                    <br />
                    Data source: ISS Datadesk
                  </div>
                  <div class="row mos-u-spacer--padding-bottom-md">
                    <div *ngIf="(esgUNDevGoalsTable$ | async)?.length"
                      class="column dsp-chart-container esgChartBorder">
                      <div dsp-chart #esgUNDevGoalsChart [chart]="esgUNDevGoalsChart$ | async" class="dsp-chart">
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(esgUNDevGoalsTable$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">
                        <thead atlas-table-header #header>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of esgUNDevGoalsHeader" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.displayLabel }}
                            </th>
                          </tr>
                        </thead>

                        <tbody atlas-table-body>
                          <tr halo-table-row
                            *ngFor="let row of esgUNDevGoalsTable$ | async | sort:header.sortOption;let index=index">

                            <ng-container *ngIf="!row.parent">
                              <td atlas-table-cell
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.name }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===1 || row.level ===0"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.overAllFund }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===2" class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.social }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===2" class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.environmental }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.alleviatingPoverty }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.attainingGenderEquality }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.combatingHunger }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.deliveringEducation }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.ensuringHealth }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.providingBasicServices }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.safeguardingPeace }}
                              </td>

                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.achievingSustainableAgricultureAndForests }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.conservingWater }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.contributingtoSustainableEnergyUse }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.mitigatingClimateChange }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.optimisingMaterialUse }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.preservingMarineEcosystems }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.preservingTerrestrialEcosystems }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight ': row.selected}">
                                {{ row.promotingSustainableBuildings }}
                              </td>
                            </ng-container>

                            <ng-container *ngIf="row.parent">
                              <td atlas-table-cell
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.name }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===1 || row.level ===0"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.overAllBenchmark }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===2" class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.social }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===2 " class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.environmental }}
                              </td>

                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.alleviatingPoverty }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.attainingGenderEquality }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.combatingHunger }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.deliveringEducation }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.ensuringHealth }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.providingBasicServices }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'social'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.safeguardingPeace }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.achievingSustainableAgricultureAndForests }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.conservingWater }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.contributingtoSustainableEnergyUse }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.mitigatingClimateChange }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.optimisingMaterialUse }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.preservingMarineEcosystems }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.preservingTerrestrialEcosystems }}
                              </td>
                              <td atlas-table-cell *ngIf="row.level ===3 && row.type === 'environmental'"
                                class="mos-u-text-right dsp-numeric-font"
                                [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight ': row.selected}">
                                {{ row.promotingSustainableBuildings }}
                              </td>
                            </ng-container>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgUNDevGoalsTable$ | async).length" class="mos-u-spacer--margin-top-sm">
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>
                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                  <div *ngIf="!((esgUNDevGoalsTable$ | async)?.length > 0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'"
                  *ngIf="((esgUNDevGoalsTable$ | async)?.length > 0)">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-DAI-export-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-DAI-download-button'" (click)="onExportPDF('dev-goals')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-DAI-export-button'" (click)="onExportCSV('dev-goals')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>



            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>

              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'"
                [haloTooltip]="esgDiversityTooltipText" [size]="'large'" icon="meeting"
                collection="users-solid"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Diversity and Inclusion: Gender Diversity on Boards
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) && (esgDiversityAndInclusionTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async) && (esgDiversityAndInclusionTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                    Good corporate governance and diversity of thought have been linked to long-term investment value.
                    Mercer looks at gender diversity on boards as one indicator of good corporate governance.
                    <br />
                    <br />
                    Data source: ISS Datadesk
                  </div>
                  <div *ngIf="(esgDiversityAndInclusionTable$ | async)?.length"
                    class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">
                        <thead atlas-table-header #header>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of diversityInclusionHeaders" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.displayLabel }}
                            </th>
                          </tr>
                        </thead>
                        <tbody atlas-table-body>
                          <tr halo-table-row
                            *ngFor="let row of esgDiversityAndInclusionTable$ | async | sort:header.sortOption">

                            <td atlas-table-cell>
                              {{ row.name }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.diBoardDiversityFund }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.diBoardDiversityBenchmark }}
                            </td>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgDiversityAndInclusionTable$ | async).length > 0"
                        class="mos-u-spacer--margin-top-sm">
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>
                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                  <div *ngIf="!((esgDiversityAndInclusionTable$ | async)?.length > 0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'"
                  *ngIf="((esgDiversityAndInclusionTable$ | async)?.length > 0)">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-DAI-export-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-DAI-download-button'" (click)="onExportPDF('diversity-inclusion')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-DAI-export-button'" (click)="onExportCSV('diversity-inclusion')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>

            </atlas-tab-content>
          </atlas-tab>
          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'"
                [haloTooltip]="esgModernSlaveryText" [size]="'large'" icon="people-blue"
                collection="display-blue"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Modern Slavery
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) && (esgModernSlaveryTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async) && (esgModernSlaveryTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                    Mercer regularly screens its investments for any severe breaches of global norms associated with the
                    ten principles of the UN Global Compact including specifically any breaches linked to modern slavery
                    and human rights abuses. The analysis shown here draws on data from ISS concerning serious
                    allegations
                    of modern slavery.
                    <br />
                    In line with our obligations under the Modern Slavery Act (2018), Mercer conducts a range of
                    activities to assess and address modern slavery risk in our operations, supply chains and investment
                    activities. Information on our corporate-wide approach can be found in our
                    <a href="https://www.mercer.com.au/content/dam/mercer/Aus/attachments/au_2021-MMC_Modern-Slavery-Statement-2020_Final-Published.pdf"
                      target="_blank">MMC
                      Modern Slavery
                      Statement</a>. Information on our approach to modern slavery specifically within investments can
                    be
                    found
                    in our
                    <a href="https://www.mercer.com.au/content/dam/mercer/attachments/asia-pacific/australia/investment/Mercer-Investment-Approach-to-Modern-Slavery_May-2021.pdf"
                      target="_blank">Investment
                      Approach to Modern Slavery</a> document.
                    <br />
                    <br />
                    Data source: ISS Datadesk
                  </div>
                  <div *ngIf="!((esgModernSlaveryTable$ | async)?.length > 0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                  <div *ngIf="(esgModernSlaveryTable$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">

                        <thead atlas-table-header #header>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of slaveryHeader" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.displayLabel }}
                            </th>
                          </tr>
                        </thead>
                        <tbody atlas-table-body>
                          <tr halo-table-row
                            *ngFor="let row of esgModernSlaveryTable$ | async | sort:header.sortOption">

                            <td atlas-table-cell>
                              {{ row.name }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.companiesRedFlag }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.porttfolioPercentRedFlag }}
                            </td>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgModernSlaveryTable$ | async).length" class="mos-u-spacer--margin-top-sm">
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>

                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'"
                  *ngIf="(esgModernSlaveryTable$ | async)?.length > 0">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-MS-export-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-MS-download-button'" (click)="onExportPDF('modern-slavery')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-MS-export-button'" (click)="onExportCSV('modern-slavery')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>

          <atlas-tab>
            <ng-template atlas-tab-label>
              <atlas-icon [haloTooltipWithArrow]="true" [haloTooltipPosition]="'bottom'" [haloTooltip]="esgProxyText"
                [size]="'large'" icon="thumb-up" collection="emoticons-solid" class="greyy"></atlas-icon>

            </ng-template>
            <atlas-tab-content>
              <div class="row">
                <div class="columns">
                  <div class="dsp-title-container">
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none">
                      Proxy Voting
                    </h3>
                  </div>
                  <p *ngIf="(date$ | async) && (esgProxyVotingTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Holdings as at end of {{ date$ | async }}
                  </p>
                  <p *ngIf="(esgDate$ | async) && (esgProxyVotingTable$ | async)?.length" class="dsp-subtitle"
                    style="margin-bottom: 1px !important;">
                    Sustainable Investment Analysis updated in {{ esgDate$ | async }}
                  </p>
                  <div class="small-12 mos-u-spacer--margin-bottom-md mos-u-spacer--margin-top-md">
                    Mercer believes that stewardship, or active ownership, helps the realisation of long-term investor
                    value of companies and markets through voting and engagement. As a shareholder of publicly listed
                    companies, Mercer has the right to vote at shareholder meetings. Mercer regards voting its shares as
                    important to our fiduciary responsibility.
                    <br />
                    The table below summarises Mercer’s voting activity over the past 6 months for the funds you are
                    invested in.
                    <br />
                    <br />
                    Data source: Glass Lewis
                  </div>
                  <div *ngIf="!((esgProxyVotingTable$ | async)?.length >  0)" class="mos-u-align-center--both"
                    [style.height.px]="100">
                    <h3>
                      No Data Available
                    </h3>
                  </div>
                  <div *ngIf="(esgProxyVotingTable$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
                    <div class="small-12 medium-12">
                      <atlas-table [customSort]="true">

                        <thead atlas-table-header #header>

                          <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of proxyHeader" [columnDef]="col"
                              (click)="onSort(col.column,header.sortOption.direction)">
                              {{ col.displayLabel }}
                            </th>
                          </tr>
                        </thead>
                        <tbody atlas-table-body>
                          <tr halo-table-row *ngFor="let row of esgProxyVotingTable$ | async | sort:header.sortOption">

                            <td atlas-table-cell>
                              {{ row.name }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.meetingsVotedNumAus }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.meetingsVotedPercentAus }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.meetingsVotedNumGlobalExAus}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.meetingsVotedPercentGlobalExAus }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.votesAgainstManagementRecPercentGlobal }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                              {{ row.supervotesNumGlobal}}
                            </td>

                          </tr>
                        </tbody>
                      </atlas-table>
                      <div *ngIf="(esgProxyVotingTable$ | async).length" class="mos-u-spacer--margin-top-sm">
                        <atlas-pagination [paginationInfo]="pagination$ | async">
                        </atlas-pagination>

                      </div>
                    </div>
                    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                      <small class="mos-u-footnote">
                        Please contact your consultant to discuss Sustainable Investment Analysis in more detail.<br>
                        Analysis may not be available for all funds across all time periods.<br>
                        Analysis is available from end June 2021 only.<br>
                        The most recently available Sustainable Investment Analysis is displayed as at the analysis
                        month
                        selected. </small>
                    </div>
                  </div>
                </div>
                <div class="columns shrink" [style.margin-left]="'auto'"
                  *ngIf="(esgProxyVotingTable$ | async)?.length>0">
                  <legacy-dropdown [position]="'right'">
                    <legacy-dropdown-label>
                      <button [id]="'esg-PV-settings-button'">
                        <!-- <atlas-icon [icon]="'more_vert'"></atlas-icon> -->
                        <atlas-icon [icon]="'menu-dots-v'" [collection]="'user-interface-solid'"
                          [size]="'large'"></atlas-icon>

                      </button>
                    </legacy-dropdown-label>

                    <legacy-dropdown-item>
                      <a [id]="'esg-PV-download-button'" (click)="onExportPDF('proxy-voting')">
                        Export as PDF
                      </a>
                    </legacy-dropdown-item>
                    <legacy-dropdown-item>
                      <a [id]="'esg-PV-export-button'" (click)="onExportCSV('proxy-voting')">
                        Export as CSV
                      </a>
                    </legacy-dropdown-item>
                  </legacy-dropdown>
                </div>
              </div>
            </atlas-tab-content>
          </atlas-tab>
        </atlas-tab-group>
      </div>
    </div>
  </div>
</dsp-content-card>